const zendesk_subdomain = process.env.REACT_APP_ZENDESK_SUBDOMAIN;
const zendesk_api_token = process.env.REACT_APP_ZENDESK_API_TOKEN;
const zendesk_user_email = process.env.REACT_APP_ZENDESK_USER_EMAIL;
const IP_URL = process.env.REACT_APP_NODE_API_URL


export const uploadAttachment = async (file_upload) => {
  //console.log("Se va a subir el archivo adjunto");
  //console.log(file_upload);
  //console.log(zendesk_subdomain);

  let fileName = file_upload.name;
  let result_return = null;

  let upload_attachment_url = `https://${zendesk_subdomain}.zendesk.com/api/v2/uploads.json?filename=${encodeURIComponent(
    fileName
  )}`;

  try {
    const response = await fetch(upload_attachment_url, {
      method: "POST",
      headers: {
        Authorization:
          "Basic " + btoa(`${zendesk_user_email}/token:${zendesk_api_token}`),
      },
      body: file_upload, // 👈 Aquí va el archivo directamente
    });

    if (!response.ok) {
      console.error(
        "Error al subir archivo:",
        response.status,
        await response.text()
      );
      return null;
    }

    const data = await response.json();
    //console.log("Respuesta API:", data);

    // Token del archivo subido
    result_return = data.upload.token;
  } catch (err) {
    console.error("Error en la subida de archivo:", err);
    return null;
  }

  return result_return;
};

export const uploadTicket = async (new_ticket) => {
  //console.log("Se va a subir el ticket");
  //console.log(new_ticket);
  let result_return = null;

  try {
    const response = await fetch(IP_URL + "ticket/new_ticket", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(new_ticket),
    });

    if (!response.ok) {
      console.error(
        "Error al crear ticket:",
        response.status,
        await response.text()
      );
      return null;
    }

    const data = await response.json();
    //console.log("Respuesta API:", data);

    result_return = data;
  } catch (err) {
    console.error("Error en la subida de ticket:", err);
    return null;
  }

  return result_return;
};
